import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import MainHeading from "../../GlobalComponents/Utils/mainHeading";
import camera from "../../Assets/about/camera.png";
import camera_1 from "../../Assets/about/camera_1.png";
import PrimeryButton from "../../ControlledComponents/PrimeryButton/PrimeryButton";
import Button3 from "../../GlobalComponents/button-style-2";
import { useNavigate } from "react-router-dom";
import Button4 from "../../GlobalComponents/button3";
import { MdOutlineReadMore } from "react-icons/md";
import { MdReadMore } from "react-icons/md";
import { AiFillFire } from "react-icons/ai";
import { useTranslation } from 'react-i18next';

export default function AboutUs() {
    const { t ,i18n} = useTranslation();
    const navigate = useNavigate();
    const aboutUsRef = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (aboutUsRef.current) {
                const rect = aboutUsRef.current.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom >= 0) {
                    setInView(true);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Check on initial load

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div ref={aboutUsRef} className={`aboutUs ${inView ? "in-view" : ""}`}>
            <div className="leftSection">
                <MainHeading width={'95%'} gap={'10px'} flexDirection={'row'} margin={"0 0 0px 0"} content1={t("aboutus.title").split(" ")[0] + " "}
  content2={t("aboutus.title").split(" ")[1]} />
                <p>
                    {t("aboutus.description")}
                </p>
                <Button4 
                    text_1={t("aboutus.readmore")} 
                    text_2={t("aboutus.readmore")} 
                    iconComponent={AiFillFire} 
                    width={"200px"}   
                    navigateClick={() => {
                        navigate("/about-us")
                    }} 
                />
            </div>
            <div className="rightSection">
                <img src={camera_1} alt="Camera" />
            </div>   
        </div>
    );
}
